"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageObject = void 0;
var ImageObject = /** @class */ (function () {
    function ImageObject() {
        // 表示済みの画像を管理するクラス
        this.image = null;
        this.filter = [];
        // 画像の読み込みと表示処理
        this.image = new Image();
        this.canvas = document.createElement('canvas');
        this.ctx = this.canvas.getContext('2d');
    }
    ImageObject.prototype.getImage = function () {
        return this.image;
    };
    ImageObject.prototype.setImage = function (img) {
        // 画像の読み込みと表示処理
        this.image = img;
        return this;
    };
    ImageObject.prototype.getCanvas = function () {
        return this.canvas;
    };
    ImageObject.prototype.setCanvas = function (canvas) {
        this.canvas = canvas;
        return this;
    };
    ImageObject.prototype.getSize = function () {
        return { width: this.image.width, height: this.image.height };
    };
    ImageObject.prototype.setImageAsync = function (src) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!src || src.length == 0) {
                    return [2 /*return*/, this];
                }
                // 画像の読み込みと表示処理
                this.image.src = src;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.image.onload = function () {
                            _this.canvas.width = _this.image.width;
                            _this.canvas.height = _this.image.height;
                            resolve(_this);
                        };
                        _this.image.onError = function () {
                            reject(new Error('画像の読み込みに失敗しました'));
                        };
                    })];
            });
        });
    };
    ImageObject.prototype.draw = function (reverse) {
        if (reverse === void 0) { reverse = false; }
        if (reverse) {
            this.ctx.save();
            this.ctx.scale(-1, 1);
            this.ctx.drawImage(this.image, -this.image.width, 0);
            this.ctx.restore();
        }
        else {
            this.ctx.drawImage(this.image, 0, 0);
        }
        return this;
    };
    // 画像の透明度を変更
    ImageObject.prototype.setOpacity = function (opacity) {
        this.ctx.drawImage(this.image, 0, 0);
        // 透明度を設定
        this.ctx.globalAlpha = opacity;
        return this;
    };
    // アニメーション(フェードイン/フェードアウト)
    // セピア化
    ImageObject.prototype.setSepia = function (num) {
        if (num === void 0) { num = 100; }
        this.ctx.drawImage(this.image, 0, 0);
        // フィルターをかける
        this.filter.push("sepia(".concat(num, "%)"));
        this.ctx.filter = this.filter.join(' ');
        // 画像データを取得
        return this.draw();
    };
    // モノクロ化
    ImageObject.prototype.setMonochrome = function (num) {
        if (num === void 0) { num = 100; }
        this.ctx.drawImage(this.image, 0, 0);
        // フィルターをかける
        this.filter.push("grayscale(".concat(num, "%)"));
        this.ctx.filter = this.filter.join(' ');
        // 画像データを取得
        return this.draw();
    };
    // ぼかし
    ImageObject.prototype.setBlur = function (num) {
        if (num === void 0) { num = 2; }
        this.ctx.drawImage(this.image, 0, 0);
        // フィルターをかける
        this.filter.push("blur(".concat(num, "px)"));
        this.ctx.filter = this.filter.join(' ');
        // 画像データを取得
        return this.draw();
    };
    // フィルターの解除
    ImageObject.prototype.clearFilter = function () {
        this.ctx.drawImage(this.image, 0, 0);
        // フィルターをかける
        this.ctx.filter = 'none';
        // 画像データを取得
        return this.draw();
    };
    return ImageObject;
}());
exports.ImageObject = ImageObject;
//# sourceMappingURL=ImageObject.js.map